
import './Contact.css';
import React, { useState, useEffect, } from 'react'
import col from "../Assets/1.jpg";

import logo from "../Assets/logo2.png";
import Aos from 'aos';
import  Footer  from "../Footer.js";

import 'aos/dist/aos.css'; 
import { Helmet } from 'react-helmet';

function About() {

    const [button,setButton] = useState(true);


   

const showButton = () =>{
  if(window.innerWidth <= 960){
    setButton(false);
  }
  else{
    setButton(true);
  }
}

useEffect(()=>{
  showButton();
},[]);
  window.addEventListener('resize',showButton);


  useEffect(()=>{
    Aos.init({duration:1000});
  },[]);




  return (
    <div style={{backgroundColor:'#f9f5ef',}}>
      <Helmet>
      <title>About us - Brown Profiles</title>
<meta name="description" content="At Brown Profiles, we aim to create a soothing luxury feel of interiors with the play of different wooden panels." />
      </Helmet>
        <title>Brown Profiles | About</title>
      <div className='bgs' style={{paddingTop:100,display:'flex',alignItems:'center'}}>

    </div>
    <div  style={{display:'flex',marginTop:button?-175:-150,justifyContent:'center',paddingBottom:button?50:100}}>
    <div  style={{display:'flex',flexDirection:'column',alignItems:'center',textAlign:'center',backgroundColor:'#f9f5ef',borderTopLeftRadius:button?'40vw':'50vw',borderTopRightRadius:button?'40vw':'50vw',width:button?'80vw':'100vw',paddingTop:button?100:75,height:button?'40vw':'50vw'}}>
        <text style={{fontSize:button?14:'2vw',fontFamily:'montserrat',letterSpacing:2}}>OUR MANIFESTO</text>
        <text style={{fontSize:button?45:'5vw',letterSpacing:1,fontFamily:'montserrat',paddingTop:30,marginLeft:button?255:'20vw',marginRight:button?255:"20vw"}}>To Create <br></br>Beautiful & Desireble <br></br>Luxury Panels <br></br>in <strong style={{color:'#855E42'}}>Wood.</strong></text>

      </div>
      </div>
      <div style={{display:'flex',flexDirection:button?'row':'column',backgroundColor:'#1e1c21',padding:'5vw'}}>
      <div className={button?'bgs2':'bgs3'} style={{paddingTop:100,display:'flex',alignItems:'center'}}>

</div>
<div data-aos="fade-up" style={{padding:button?50:30,fontFamily:'montserrat',display:'flex',flexDirection:'column',width:button?'50vw':'90vw',color:'white',paddingLeft:button?50:0}}>

  <text  style={{letterSpacing:4,fontSize:12,color:'grey'}}>A WOODEN LUXURY</text>
  <text style={{fontWeight:'bolder',fontSize:'xxx-large',lineHeight:1.2,paddingTop:15}}>BROWN <br></br>PROFILES</text>
  <text style={{fontSize:14,paddingTop:15,paddingRight:button?50:0,color:'#fafafa'}}>Founder, Architect, and explorer of aesthetics and luxury, Lokesh being very creative and selective about the materials and quality has never settled for less. After a long journey of explorations with different wood qualities, Lokesh selected a range of premium quality woods which has further been curated with the best designs and unmatched finishing. Proudly launching Brown Profiles to take up the responsibility to stand by his name and providing the best interiors, this journey has now started.
We believe in establishing fruitful business relationships with our clients and customers during this journey.</text>
</div>
</div>

   <div data-aos="zoom-in" style={{fontFamily:'Canela',padding:'20vh',display:'flex',flexDirection:'column',alignItems:'center',textAlign:'center'}}>
      <img alt='Brown Profiles Logo' style={{height:60,width:60,marginBottom:50}} src={logo}/>
      <text style={{fontSize:'large',color:'#1d1c18',fontWeight:300,width:button?'60vw':'80vw'}}>We belong to the designer's family hence, creating and visualizing designs has always been our practice, we are suckers for aesthetics and class. Along with appearance we also believe in the quality and durability of any product, when we visualize Brown Profiles we aim at creating a soothing luxury feel of interiors with the play of differently designed wooden profiles to make your space a class apart. The purity and texture of our wood will surely steal your hearts.</text>
    </div>
    


<div style={{display:'flex',justifyContent:'center',alignItems:'center',fontFamily:'montserrat',letterSpacing:button?15:5,}}>
  <div style={{display:'flex',flexDirection:'column',position:'absolute',alignItems:'center'}}>
  <text className='underline-hover-effect' style={{color:'white',fontSize:button?'large':'small'}}>A LUXURY COLLECTION</text>
  </div>
  <img alt='Fluted panel background' style={{width:'90vw',height:button?'50vh':'30vh',margin:'5vw'}} src={col}/>
</div>

<Footer/>
    </div>
  );
}

export default About;